"use client";
import React, { useState } from "react";
import { ExpandableInsightsProps } from "./types";
import IndustryInsightItem from "./IndustryInsightItem";
import useTranslations from "@/i18n/useTranslations";

export default function ExpandableInsights({
  insights,
  hideTitle = false,
  oneColumn = false,
  disableExpand = false,
}: ExpandableInsightsProps) {
  const t = useTranslations("Common");
  const tExpand = useTranslations("ExpandableBlock");
  const [isExpanded, setIsExpanded] = useState(false);

  const visibleCountMobile = 2;
  const visibleCountDesktop = 4;

  return (
    <div className="bg-inherit flex flex-col gap-12">
      {!hideTitle && (
        <h2 className="text-primary-500 font-bold md:text-3xl mt-0 mb-0 text-left">
          {t("industryInsights")}
        </h2>
      )}

      <div
        className={`grid gap-6 ${oneColumn ? "grid-cols-1" : "md:grid-cols-2"}`}
      >
        {insights
          .slice(0, isExpanded ? insights.length : visibleCountMobile)
          .map(({ value }, index) => (
            <IndustryInsightItem
              key={`insight-${index + 1}`}
              value={value}
              isMobile
            />
          ))}

        {insights
          .slice(0, isExpanded ? insights.length : visibleCountDesktop)
          .map(({ value }, index) => (
            <IndustryInsightItem key={`insight-${index + 1}`} value={value} />
          ))}
      </div>

      {insights.length > visibleCountMobile && !disableExpand && (
        <button
          data-testid="expandable-insights-trigger"
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-base text-primary font-semibold underline self-start block md:hidden"
        >
          {isExpanded ? tExpand("showLess") : tExpand("showMore")}
        </button>
      )}

      {insights.length > visibleCountDesktop && !disableExpand && (
        <button
          data-testid="expandable-insights-trigger"
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-base text-primary font-semibold underline self-start hidden md:block"
        >
          {isExpanded ? tExpand("showLess") : tExpand("showMore")}
        </button>
      )}
    </div>
  );
}
